import axios from "axios";

export const BACKEND = process.env.REACT_APP_BACKEND_URL;
export const api = axios.create({ baseURL: `${BACKEND}/api`, withCredentials: true });

const csrf = { staff: null, customer: null };
export const setCsrf = (kind, token) => {
  csrf[kind] = token;
};

const GUEST_KEY = "lc_guest_token";
export const guestToken = {
  get: () => {
    try { return localStorage.getItem(GUEST_KEY); } catch { return null; }
  },
  set: (t) => {
    try { localStorage.setItem(GUEST_KEY, t); } catch { /* storage unavailable */ }
  },
  clear: () => {
    try { localStorage.removeItem(GUEST_KEY); } catch { /* storage unavailable */ }
  },
};

const isStaffUrl = (url) => url.startsWith("/admin") || url.startsWith("/auth/staff");

api.interceptors.request.use((cfg) => {
  const url = cfg.url || "";
  const method = (cfg.method || "get").toUpperCase();
  if (!["GET", "HEAD", "OPTIONS"].includes(method)) {
    const tok = isStaffUrl(url) ? csrf.staff : csrf.customer;
    if (tok) cfg.headers["X-CSRF-Token"] = tok;
  }
  if (!isStaffUrl(url)) {
    const g = guestToken.get();
    if (g) cfg.headers["X-Guest-Token"] = g;
  }
  return cfg;
});

api.interceptors.response.use((r) => {
  if (r.data && typeof r.data === "object" && r.data.guest_token) guestToken.set(r.data.guest_token);
  return r;
});

export const errMsg = (e, fallback = "Something went wrong. Please try again.") => {
  const d = e?.response?.data;
  if (d?.detail && typeof d.detail === "string") return d.detail;
  if (e?.response?.status === 0 || e?.code === "ERR_NETWORK") return "Network unavailable. Please check your connection.";
  return fallback;
};
export const errCode = (e) => e?.response?.data?.error?.code;

export const media = (url, w = 900) => {
  if (!url) return null;
  if (url.startsWith("/api/")) return `${BACKEND}${url}`;
  if (url.includes("images.unsplash.com") && !url.includes("?")) return `${url}?w=${w}&q=80&auto=format&fit=crop`;
  return url;
};

export const newKey = () => (window.crypto?.randomUUID ? window.crypto.randomUUID() : `${Date.now()}-${Math.random().toString(36).slice(2)}`);
